module.exports = __webpack_public_path__ + "static/img/pico40.9a065ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico40.png
// module id = SFaZ
// module chunks = 0